import { createAsyncThunk } from "@reduxjs/toolkit";

import type { LoadOneProjectPayloadReturn } from "Reducers/project/project";

export const loadOneProjectHelper = createAsyncThunk(
  "app/project_reducer/load_one_project_helper",
  ({
    project,
    projectMe,
    organizations,
    organizationId
  }: LoadOneProjectPayloadReturn) => {
    return {
      project,
      projectMe,
      organizations,
      organizationId
    };
  }
);
